import memoize from './memoize';

const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/;

export default memoize(message => value =>
	value ? (passwordPattern.test(value) ? undefined : message) : undefined
);
